$(document).ready(function() {

$win = $(window);
$doc = $(document);
$body = $("body");
  

//-- Mobile Menu
(function() {
	const $nav = $("#custom-header");
    const $btn = $("#mobile-menu-btn");
  	const $parentLink = $nav.find("li.parent-link > a");

    $btn.on("click", function() {
        $(this).toggleClass("active");
        $nav.toggleClass("open").find("li.parent-link.opened").removeClass("opened").find("ul.sub-links").hide();
      	$("body").toggleClass("menu-opened");
    });//.on click
  
  	$parentLink.on("click", function(e) {
    	const $this = $(this);
      	const $parent = $this.parent();
      	//If closed
      	if (!$parent.hasClass("opened") && $nav.hasClass("open")) {
    		e.preventDefault();
          	$parent.siblings(".opened").removeClass("opened").find("ul.sub-links").slideUp().end().end().addClass("opened").find("ul.sub-links").slideDown();
        }
      	else if ($parent.hasClass("opened")) {
        	$parent.removeClass("opened").find("ul.sub-links").slideUp();
      	}
  	});//.on click
  	
})();




//-- Home Page
if ($body.hasClass("template-index")) {
  (function() {
  	const $homeSlider = $(".home-main-slider");
    const $testimonialsSlider = $(".testimonials-slider");
    
    $homeSlider.slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: $homeSlider.attr("data-autoplay"),
  	  autoplaySpeed: $homeSlider.attr("data-speed"),
      responsive: [
        {
          breakpoint: 767,
          settings: {
            adaptiveHeight: true
          }
        }
      ]
    });
    
    $testimonialsSlider.slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: $testimonialsSlider.attr("data-autoplay"),
  	  autoplaySpeed: $testimonialsSlider.attr("data-speed"),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            mobileFirst: true,
        	adaptiveHeight: true
          }
        }
      ]
    });
    
  })();
}//homepage




//-- Collections Page
if ($body.hasClass("template-collection")) {
  (function() {
    const $cartCount = $("#CartCount");
    
  	//Add to cart function
    $(".atc-btn").on("click", function(e) {console.log("click");
        e.preventDefault();
        const productID = $(this).attr("data-prodId");console.log("product ID:", productID);
        //const quantity = $(this).find("input").val();//console.log("quantity:", quantity);

        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            id: productID,
            quantity: 1//quantity
          },
          success: function success(response) {console.log("cart add response:", response);

            /* GET NEW CART INFO TO UPDATE ICON */
              $.ajax({
                url: '/cart',
                success: function success(response) {//console.log("cart success response:", response); //entire page html

                      //Find total items in cart inside #cart-total on cart page
                      const cartCount = $(response).find("#total-cart-count").text();//console.log("new cart count", cartCount);

                      //Update cart quantity in header
                      $cartCount.text(cartCount);

                } //success
              }); //.ajax

          },
          error: function(req, status, err) {
              console.log("error response:", JSON.stringify(req)); 
          }

        });//.ajax

    });//.on click
    
    
  })();
}//collection page
  

  
});//.ready